type StrArrValObj = {[keyName: string]: string[]};

// 降序排序，Others放最后
const getSortOthersData = (
  data: StrArrValObj | null,
) => {
  if (data) {
    let filterOthersItems = [], othersItems = [];
    for (const key in data) {
      if (key?.toLowerCase() == 'others') {
        othersItems.push({['Others']: data?.[key]});
      } else {
        filterOthersItems.push({[key]: data?.[key]});
      }
    }
    let sortFilterOthersItems: StrArrValObj[] = [], sortOthersItems: StrArrValObj[] = [];
    if (filterOthersItems?.length) {
      sortFilterOthersItems = filterOthersItems?.sort((a, b) => (Object?.entries(b)?.[0]?.[1]?.length - Object?.entries(a)?.[0]?.[1]?.length)) || [];
    }
    if (othersItems?.length) {
      sortOthersItems = othersItems?.sort((a, b) => (Object?.entries(b)?.[0]?.[1]?.length - Object?.entries(a)?.[0]?.[1]?.length)) || [];
    }
    const items: StrArrValObj[] = [...sortFilterOthersItems, ...sortOthersItems];
    const res = items?.reduce((o, t) => {
      o = {...o, ...t};
      return o;
    }, {});

    return JSON.stringify(res) === '{}' ? null : res;
  }

  return null;
}

// 将空的键名改成Others
const getObjectData = (
  data: {
    [keyName: string]: string[] | null,
  } | null | undefined,
) => {
  if (Object.prototype.toString.call(data) === '[object Object]') {
    const res: {[keyName: string]: any} = {};
    for (const key in data) {
      res[!key ? 'Others' : key] = Array.isArray(data?.[key]) ? data?.[key] : [];
    }
    return getSortOthersData(JSON.stringify(res) === '{}' ? null : res);
  }

  return null;
}

// 将数组中的每个对象拉平到一个对象中
const getArrayData = (
  data: {
    [keyName: string]: string[] | null,
  }[] | null | undefined,
) => {
  if (Array.isArray(data) && data?.length) {
    let res = {};
    for (let i = 0; i < data?.length; i ++) {
      const t = data?.[i];
      const newT = getObjectData(t);
      if (newT) {
        res = {
          ...res,
          ...newT,
        }
      }
    }
    return getSortOthersData(JSON.stringify(res) === '{}' ? null : res);
  }

  return null;
}


export {
  getSortOthersData,
  getObjectData,
  getArrayData,
}
